import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/guide-1.png'
import _imports_1 from '../../assets/images/guide-2.png'


const _withScopeId = n => (_pushScopeId("data-v-4e6e6f50"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))

import { reactive, onUnmounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Swipe, SwipeItem } from 'vant'
import { showLoading, dialog } from '@/utils/vant'
import { useLogin } from '@/business/login'
import service from '@/services'
import plus from '@/utils/h5plus'

const countdown = 1  // 倒计时秒数


export default /*#__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

const { logining, initBaseData } = useLogin()
const route = useRoute()
const router = useRouter()
const state = reactive({
  showGuide: false,
  //showGuide: (!plus.hasPlus() || localStorage.getItem('muchinfo_app_showguide') === 'false') ? false : true, // 是否显示引导页
  second: countdown, // 剩余秒数
  currentRate: 100, // 当前进度
  rate: 100, // 目标进度
})

const init = () => initBaseData(true) // 初始化数据
const onLoad = state.showGuide ? Promise.resolve() : init()

// 倒计时
const timer = window.setInterval(() => {
  state.second--
  state.rate = (100 / countdown) * state.second
  if (state.second <= 0) {
    clearInterval(timer)
    // 判断是否首次打开应用
    if (!state.showGuide) {
      skip(onLoad)
    }
  }
}, 1000)

// 跳过广告
const skip = (promise: Promise<void>) => {
  clearInterval(timer)
  const toast = logining.value ? showLoading() : undefined

  promise.then(() => {
    localStorage.setItem('muchinfo_app_showguide', 'false')
    const redirect = route.query.redirect
    if (redirect && redirect !== '/') {
      router.replace(redirect.toString())
    } else {
      router.replace({ name: 'home-market' })
    }
  }).catch((err) => {
    if (service.isReady) {
      router.replace({ name: 'home-market' })
    } else {
      tryInit(err)
    }
  }).finally(() => {
    toast?.close()
  })
}

// 初始化失败重试
const tryInit = (message: string) => {
  dialog({
    message,
    showCancelButton: plus.hasPlus(),
    cancelButtonText: '退出',
    confirmButtonText: '重试'
  }).then(() => {
    skip(init())
  }).catch(() => {
    plus.quit()
  })
}

plus.setFullSreen()
onUnmounted(() => plus.exitFullSreen())

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "boot",
    style: _normalizeStyle(`background-image: url(${'./app/splashscreen/1080x1920.png'});`)
  }, [
    (state.showGuide)
      ? (_openBlock(), _createBlock(_unref(Swipe), {
          key: 0,
          class: "boot__guide",
          loop: false
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(SwipeItem), null, {
              default: _withCtx(() => [
                _createElementVNode("img", { src: './app/splashscreen/1080x1920.png' }, null, 8, _hoisted_1)
              ]),
              _: 1
            }),
            _createVNode(_unref(SwipeItem), null, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_unref(SwipeItem), null, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  src: _imports_1,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (skip(init())))
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 4))
}
}

})